export const STRIPE_KEY = "pk_test_lR97uKfkq0k3RIz8XZccLdrV00Vh0kQ6GW";
